import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import theme from "styles/theme";
import Text from "components/form/text-inline";
import Globalize from "globalize";
import IconButton from "material-ui/IconButton";
import Trash from "components/icons/trash";
import debounce from "lodash/debounce";
import { merge, $, media, presets } from "glamor";
import classNames from "classnames";
import DragHandle from "./drag-handle";
//import { SortableElement } from 'react-sortable-hoc';
import SortableElement from "./views/sortable";

let styles;
const getStyles = () => {
    if (!styles) {
        styles = merge(
            {
                position: "relative",
                minHeight: "30px",
                marginLeft: "32px",
            },
            $(" .separatorLabel", {
                maxHeight: "54px",
                lineHeight: "24px",
                fontSize: "16px",
                fontWeight: "bold",
                color: theme.palette.darkerGrey,
                transition: "all .12s ease-in",
                background: "#fff",
                borderBottom: `2px solid ${theme.palette.darkerGrey}`,
                overflow: "hidden",
                marginRight: "5px",
            }),
            $(" .separatorLabelHover", {
                marginLeft: "32px",
            }),
            $(" .deleteSeparator", {
                position: "absolute !important",
                top: "-12px",
                right: "-12px",
                zIndex: "3 !important",
            }),
            $(" .listView", {
                right: "9px !important",
            }),
            media(
                presets.phablet,
                merge({
                    marginLeft: "0px",
                }),
            ),
            media("(max-width: 550px)", {
                marginLeft: "0px",
            }),
        );
    }
    return styles;
};

/** @augments {PureComponent<any, any>} */
class Separator extends PureComponent {
    static propTypes = {
        catalogEntry: PropTypes.object.isRequired,
        editable: PropTypes.bool,
        focussed: PropTypes.bool,
        style: PropTypes.object,
        isDragging: PropTypes.bool,
        actions: PropTypes.object,
        ItemView: PropTypes.func,
        list: PropTypes.bool,
        emptySection: PropTypes.bool,
    };

    static defaultProps = {
        editable: false,
        focussed: false,
        isDragging: false,
        emptySection: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            hover: false,
            label: props.catalogEntry.label || "",
        };
        this.handleLabelChange = debounce(this.handleLabelChange.bind(this), 600);
        this.handleEnter = this.handleHover.bind(this, true);
        this.handleLeave = this.handleHover.bind(this, false);
        this.handleDelete = this.handleDelete.bind(this);

        this.supportsTouch = "ontouchstart" in window || navigator.msMaxTouchPoints;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.catalogEntry !== this.props.catalogEntry) {
            this.setState({ label: nextProps.catalogEntry.label || "" });
        }
    }

    handleHover(hover) {
        this.setState({ hover });
    }

    handleDelete(e) {
        e.stopPropagation();
        const { catalogEntry, actions } = this.props;
        actions.onDelete(catalogEntry);
    }

    handleLabelChange(label) {
        const { catalogEntry, actions } = this.props;
        actions.onUpdate(catalogEntry, { label });
    }

    render() {
        const { catalogEntry, editable, focussed, style, isDragging, connectDragSource, list, emptySection } =
            this.props;
        const { hover, label } = this.state;

        let labelField;
        if (editable) {
            labelField = (
                <Text
                    defaultValue={label || ""}
                    editable={true}
                    placeholder={Globalize.formatMessage("Enter Label")}
                    onChange={this.handleLabelChange}
                    style={{ marginBottom: "4px" }}
                    editorStyle={{
                        display: "inline-block",
                        width: "calc(100% - 48px)",
                    }}
                    defaultFocus={focussed}
                    multiLine={false}
                    maxLength={128}
                />
            );
        } else {
            labelField = catalogEntry.label;
        }

        const showRemoveIcon = !isDragging && editable && (this.supportsTouch || hover);
        return (
            <div
                {...getStyles()}
                style={Object.assign({}, style, {
                    left: "5px",
                })}
                onMouseEnter={this.handleEnter}
                onMouseLeave={this.handleLeave}
            >
                {editable && (
                    <DragHandle connectDragSource={connectDragSource} style={hover ? { opacity: 1 } : { opacity: 0 }} />
                )}
                <div
                    className={classNames("separatorLabel", {
                        separatorLabelHover: editable && hover,
                    })}
                >
                    {labelField}
                </div>
                {showRemoveIcon && (
                    <IconButton
                        onClick={this.handleDelete}
                        className={classNames("deleteSeparator", { listView: list })}
                    >
                        <Trash color={theme.palette.error} />
                    </IconButton>
                )}
                {emptySection && (
                    <p style={{ marginTop: "5px", textAlign: "center" }}>
                        {Globalize.formatMessage("No product found")}
                    </p>
                )}
            </div>
        );
    }
}

export const SortableSeparator = SortableElement(Separator);

export default Separator;
